<template>
  <div>
    <div class="flex items-center">
      <DrInput ref="startDate" v-model="startDateDisplay" placeholder="Start Date" data-label="Start Date" readonly @click="setDateToSelect('start')" /> <span class="inline-block mx-2 mt-6">→</span>
      <DrInput ref="endDate" v-model="endDateDisplay" placeholder="End Date" data-label="End Date" readonly @click="setDateToSelect('end')" />
    </div>
    <DatePicker
      v-show="dateToSelect"
      ref="datePicker"
      v-bind="$attrs"
      :highlighted="highlighted"
      :inline="true"
      class="datepicker mt-4"
      :class="[{ 'only-start-selected': startDate && !endDate }]"
      format="d MMMM yyyy"
      :open-date="openDate"
      use-utc
      @selected="handleSelected"
      @selectedDisabled="e => $emit('selectedDisabled', e)"
    />
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'

export default {
  components: {
    DatePicker,
  },
  props: {
    placeholder: {
      type: [String, Date],
      default: '',
    },
    startDate: {
      type: [String, Date],
      default: null,
    },
    endDate: {
      type: [String, Date],
      default: null,
    },
  },
  data () {
    return {
      dateToSelect: null,
    }
  },
  computed: {
    openDate () {
      return (this.dateToSelect === 'start') ? this.startDate : this.endDate || this.startDate
    },
    startDateDisplay () {
      if (!this.startDate) return null
      const formatedDate = new Date(this.startDate).toLocaleString('en-GB').split(', ')[0]
      return formatedDate
    },
    endDateDisplay () {
      if (!this.endDate) return null
      const formatedDate = new Date(this.endDate).toLocaleString('en-GB').split(', ')[0]
      return formatedDate
    },
    highlighted () {
      return {
        to: this.endDate || this.startDate,
        from: this.startDate,
      }
    },
  },
  mounted () {
    this.$refs.datePicker.selectedDate = this.endDate < Date.now() ? Date.now() : this.endDate
  },
  methods: {
    handleSelected (e) {
      if (this.dateToSelect === 'start' || !this.startDate || e <= this.startDate) {
        this.$emit('selectedEnd', null)
        this.setDateToSelect('end')
        this.$refs.endDate.$refs.input.focus()
        this.$emit('selectedStart', e)
        return
      } else {
        this.setDateToSelect(null)
        this.$emit('selectedEnd', e)
      }

      this.$emit('selected', e)
    },
    setDateToSelect (val) {
      this.$emit('selecting', val)
      this.dateToSelect = val
    },
  },
}
</script>

<style scoped>

/* Highlight selected date range */
.datepicker::v-deep .highlighted {
  @apply bg-grey-200 rounded-none
}

.datepicker::v-deep .highlight-start {
  @apply rounded-l
}
.datepicker::v-deep .highlight-end {
  @apply rounded-r
}

.datepicker::v-deep .highlight-start,
.datepicker::v-deep .highlight-end {
  @apply bg-blue-400 text-white !important
}

</style>
